import { FC } from 'react';
import Container from '~/components/Container';
import Divider from '~/components/Divider';
import Colors from '~/constants/colors';
import styles from './ProductMatching.module.scss';

import { Identifiers } from '~/constants/enum';
import useClient from '~/hooks/useClient';
import useCmsBlocks from '~/hooks/useCmsBlocks';
import ProductMatchingSkeleton from './ProductMatching.skeleton';
interface ProductMatchingProps {}

const ProductMatching: FC<ProductMatchingProps> = ({}) => {
    const isClient = useClient();
    const { cmsBlocks, loading } = useCmsBlocks([Identifiers.ProductMatching]);

    const _cmsBlock = cmsBlocks[Identifiers.ProductMatching]?.content;

    const _title = cmsBlocks[Identifiers.ProductMatching]?.title;

    if (!isClient) {
        return <ProductMatchingSkeleton />;
    }
    if (loading) {
        return <ProductMatchingSkeleton />;
    }
    if (!_cmsBlock) {
        return null;
    }

    return (
        <Container rootClassName={styles.shoes_matching_wrapper} className={styles.shoes_matching}>
            <div className="flex flex-col gap-3">
                <Divider
                    text={_title}
                    className="text-xl lg:text-3xl font-bold text-gray-900"
                    dividerColor={Colors.DIVIDER_COLOR}
                />
            </div>
            {_cmsBlock && <div dangerouslySetInnerHTML={{ __html: _cmsBlock }} />}
        </Container>
    );
};

export default ProductMatching;
